import {styled} from '@material-ui/core'

export const IconsContainer = styled('div')({
  display: 'flex',
  gap: '10px',
})
